import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Storage } from 'aws-amplify';
import { getUrlWithToken } from '../../../../utils';
import { CONSTANTS } from '../../../../constants/constants';
import { config } from '../../../../constants';
import { connect } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.error.main,
    borderColor: theme.palette.error.main
  }
}));

const CardButton = ({ bundle, handleDeleteFlow, launchBundle, role }) => {
  const [xclFile, setXclFile] = useState();
  const { t } = useTranslation();
  const { status } = bundle;
  const classes = useStyles();
  const hasPermission = [CONSTANTS.ROLES.ADMIN, CONSTANTS.ROLES.EDITOR].includes(role);

  useEffect(() => {
    const downloadFileFromS3 = async () => {
      const urlDocumentMainXCL = await Storage.get(bundle.fileUrlTemplate);
      setXclFile(urlDocumentMainXCL);
    };
    downloadFileFromS3();
  }, []);

  return (
    <>
      {(status === CONSTANTS.BUNDLE.STATUS.READY || status === CONSTANTS.BUNDLE.STATUS.SEND_TO_SIGN || status === CONSTANTS.BUNDLE.STATUS.SIGNED) &&
        <Grid item>
          <Button
            variant='contained'
            color='primary'
            component={RouterLink}
            to={`/bundle/detail/${bundle.id}`}
          >
            {t('bundleMenu:viewBundle')}
          </Button>
        </Grid>
      }
      {status === CONSTANTS.BUNDLE.STATUS.SIGNED &&
      <Grid item>
        <Button
          variant='contained'
          color='primary'
          onClick={() => getUrlWithToken(`${config.FIRMA_FRONT_URL}/validate/${bundle.flowId}`)}
        >
          {t('bundleMenu:viewSignedBundle')}
        </Button>
      </Grid>
      }
      {hasPermission && status === CONSTANTS.BUNDLE.STATUS.INIT &&
        <>
          <Grid item>
            <Button
              variant='contained'
              color='primary'
              onClick={() => window.open(xclFile, '_blank')}
            >
              {t('bundleMenu:downloadXLS')}
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant='contained'
              color='primary'
              component={RouterLink}
              to={`/bundle/upload/${bundle.id}`}
            >
              {t('bundleMenu:uploadXLS')}
            </Button>
          </Grid>
        </>
      }
      {(hasPermission && status === CONSTANTS.BUNDLE.STATUS.READY) &&
        <Grid item>
          <Button
            variant='contained'
            color='primary'
            target='_blank'
            onClick={() => launchBundle(true)}
          >
            {t('bundleMenu:launchFlow')}
          </Button>
        </Grid>
      }
      {(hasPermission && status !== CONSTANTS.BUNDLE.STATUS.SEND_TO_SIGN) &&
        <Grid item>
          <Button
            variant='outlined'
            classes={{ root: classes.root }}
            aria-label='delete'
            onClick={() => handleDeleteFlow(true)}
          >
            {t('bundleMenu:remove')}
          </Button>
        </Grid>
      }
      {hasPermission && status === CONSTANTS.BUNDLE.STATUS.SEND_TO_SIGN &&
        <Grid item>
          <Button
            variant='outlined'
            color='primary'
            onClick={() => handleDeleteFlow(true)}
          >
            {t('cardButton:cancel')}
          </Button>
        </Grid>
      }
    </>
  );
};

CardButton.propTypes = {
  bundle: PropTypes.object.isRequired,
  handleDeleteFlow: PropTypes.func.isRequired,
  launchBundle: PropTypes.func.isRequired
};

const mapStateToProps = (state) => {
  return {
    role: state.config.role
  };
};

export default connect(mapStateToProps, null)(CardButton);
